import { Tooltip } from '@material-ui/core';
import styled from 'styled-components';
import { SCATTER_POINTS_LIMIT } from './useFetchData/usePayload';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import { LINE_HEIGHT } from 'common/constants/sizes';

const StyledTopLimitAlert = styled.div`
  margin-left: auto;
`;

const TopLimitAlert = () => {
  return (
    <StyledTopLimitAlert>
      <Tooltip
        placement='top'
        title={
          <Flex padding='x-small' maxWidth='18rem'>
            <Text size='medium' lineHeight={LINE_HEIGHT.medium}>
              Top {SCATTER_POINTS_LIMIT} data points presented;
              <br />
              Select a shorter time frame to refine granularity.
            </Text>
          </Flex>
        }
      >
        <Icon name='infoOutlined' color='dodgerBlue' size='smaller' />
      </Tooltip>
    </StyledTopLimitAlert>
  );
};

export default TopLimitAlert;
